import ApiService from "./ApiService"
import appConfig from '../configs/app.config'

export async function getAnketRaporlari (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getsurveyreport',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        params: {
            start_date: data.start_date,
            end_date: data.end_date,
            type: data.type
        }
    })
}
// Distile Sıcak Raf ürünü resimleri çekilenler
export async function getVisits (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getvisits?start_date='+data.start+'&end_date='+data.end,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// burası kesin get ama servisi kontrol et dönüşü resim olacak
export async function getImageFile (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getimagefile/'+data.filename,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: 'blob', // Resim dosyaları için blob tipinde yanıt al
        data
    })
}

export async function getDashboardReports (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'mobreport',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

export async function getDegerlendirmeForms (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'degerlendirmeFormlariWS',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

export async function getReports (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'mobreportnew',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}


// Temsilci Ziyaret İstatistiklerini döndürür
export async function getTransactionsSSM (data) {
    return ApiService.fetchData({
        url: 'https://labelcci.neocortexs.com/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// KPI Skorları döndürür
export async function getKpiScoreVisits (data) {
    return ApiService.fetchData({
        url: 'https://labelcci.neocortexs.com/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// Genel Raporları Döndürür
export async function getGeneralReports (data) {
    return ApiService.fetchData({
        url: 'https://labelcci.neocortexs.com/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// Genel Servis istekleri için kullanılır
export async function getVariableService (data) {
    return ApiService.fetchData({
        url: 'https://labelcci.neocortexs.com/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

export async function getKPIscoreTrends (params) {
    return ApiService.fetchData({
        url: '/stats/kpi_trends',
        method: 'get',
        params
    })
}


export async function getKPIscorePer (params) {
    return ApiService.fetchData({
        url: '/stats/kpi_per',
        method: 'get',
        params
    })
}